import { Theme, ThemeCardProps } from '../ThemeCard';

export const findThumbnailTheme = ({
  featured,
  theme,
  selected,
  themeFamily,
}: Pick<ThemeCardProps, 'featured' | 'selected' | 'themeFamily'> & { theme: Theme }) => {
  let thumbnailTheme = null;
  if (featured && theme?.id !== featured && !selected) {
    thumbnailTheme = themeFamily?.themes?.find(t => {
      return t?.id === featured;
    });
  }
  if (selected && theme?.id !== selected) {
    thumbnailTheme = themeFamily?.themes?.find(t => {
      return t?.id === selected;
    });
  }
  return thumbnailTheme || theme;
};
